const fieldStyles = (theme) => ({
  root: { '&:not(:last-child)': { marginBottom: theme.spacing(2) } },
});

export default fieldStyles;
